import _slicedToArray from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
function getOnlineStatus() {
  return typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;
}
function useOnlineStatus() {
  var _useState = useState(getOnlineStatus()),
    _useState2 = _slicedToArray(_useState, 2),
    onlineStatus = _useState2[0],
    setOnlineStatus = _useState2[1];
  var goOnline = function goOnline() {
    setOnlineStatus(true);
  };
  var goOffline = function goOffline() {
    setOnlineStatus(false);
  };
  useEffect(function () {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return function () {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);
  return onlineStatus;
}
export default (function () {
  return useOnlineStatus();
});